module.exports = __webpack_public_path__ + "img/cocacola-classic.47cbba24.png";